import { render } from "./MultiField.vue?vue&type=template&id=720fea87&scoped=true"
import script from "./MultiField.vue?vue&type=script&lang=js"
export * from "./MultiField.vue?vue&type=script&lang=js"

import "./MultiField.vue?vue&type=style&index=0&id=720fea87&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720fea87"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
